////////////////////////////////////////////////////////////////////////////////////
// Pagination
////////////////////////////////////////////////////////////////////////////////////

// Toggle for enabling or disabling debug logging
const DEBUG_MODE = false; // Set to `false` in production to disable console logs

let isFilterChanged = false; // Track if any filter has changed

// Function to scroll to the closest section containing the cardsWrapper, accounting for its actual margin
function scrollToCards(cardsWrapper) {
  if (cardsWrapper) {
    const closestSection = cardsWrapper.closest('section'); // Find the closest section ancestor

    if (closestSection) {
      // Get the computed margin-top of the closest section
      const computedStyle = window.getComputedStyle(closestSection);
      const marginTop = parseFloat(computedStyle.marginTop) || 0;

      // Calculate the scroll position, accounting for the margin
      const sectionTop = closestSection.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: sectionTop - marginTop,
        behavior: 'smooth'
      });
    } else if (cardsWrapper.parentElement) {
      // Fallback to scrolling to the parent element if no section is found
      const parentTop = cardsWrapper.parentElement.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: parentTop,
        behavior: 'smooth'
      });
    }
  }
}

////////////////////////////////////////////////////////////////////////////////////
// Block Comment Here
////////////////////////////////////////////////////////////////////////////////////
document.addEventListener('DOMContentLoaded', function () {
  // Element references for filter form, pagination, and results container
  const paginationContainer = document.querySelector('.section-pagination .js-pagination');
  const filterForm = document.querySelector('.section-pagination form');
  const filterFormPostType = filterForm ? filterForm.getAttribute('data-post-type') : 'post';
  const postsGridClassName = filterForm ? filterForm.getAttribute('data-post-grid') : null;
  const postsGrid = postsGridClassName ? document.querySelector(`.${postsGridClassName}`) : null;

  if (DEBUG_MODE) {
    console.log('Pagination Container:', paginationContainer);
    console.log('filterForm:', filterForm);
    console.log('filterPostType:', filterFormPostType);
    console.log('Cards Grid:', postsGrid);
  }

  // Handle the AJAX request for filtering careers
  function filterPosts(page = 1) {
    const formData = new FormData(filterForm); // Serialise form data
    formData.set('paged', page); // Set the current page number in the form

    // Convert form data to a query string
    const queryString = new URLSearchParams(formData).toString();

    // Conditional logging based on DEBUG_MODE
    if (DEBUG_MODE) {
      console.log('Form Data:', queryString); // DEBUG: Log form data before sending
    }

    // Send the AJAX request
    fetch(`${window.location.origin}/wp-admin/admin-ajax.php?action=nous_pagination_${filterFormPostType}&${queryString}`, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => response.json()) // Parse the response as JSON
      .then(data => {
        if (DEBUG_MODE) {
          console.log('AJAX Response:', data); // DEBUG: Log the entire response
        }

        // Check if the AJAX request was successful
        if (data.success) {
          // Update the posts grid with the returned content
          if (postsGrid && data.data.cards_html) {
            postsGrid.innerHTML = data.data.cards_html;
          }

          // Update pagination controls (e.g., previous/next buttons)
          if (paginationContainer && data.data.pagination_html !== '') {
            paginationContainer.innerHTML = data.data.pagination_html;

            // Rebind pagination events after pagination controls are updated
            bindPaginationEvents();

          } else if (paginationContainer) {
            paginationContainer.innerHTML = ''; // Clear pagination if no results
          }

          // Update the browser URL to reflect the current filter state (for sharing)
          const updatedUrl = `?${queryString}`;
          history.pushState(null, '', updatedUrl);
        } else {
          // Handle the case where no results are returned
          console.error('Failed to retrieve filtered posts data.');

          if (paginationContainer) {
            paginationContainer.innerHTML = ''; // Clear pagination
          }
        }
      })
      .catch(error => {
        // Handle any AJAX errors
        console.error('Error:', error);
      });
  } // END filterPosts

  // Bind pagination link click events
  function bindPaginationEvents() {
    if (paginationContainer) {
      const paginationLinks = paginationContainer.querySelectorAll('a');
      paginationLinks.forEach(link => {
        link.addEventListener('click', function (event) {
          event.preventDefault(); // Prevent default link behavior
          const page = new URL(link.href).searchParams.get('paged'); // Extract the page number
          filterPosts(page); // Fetch the content for the selected page

          // Scroll to the filter block after AJAX is complete
          setTimeout(scrollToCards(postsGrid), 300);
        });
      });
    }
  }

  // Bind pagination links on initial page load
  bindPaginationEvents();

  // Load the initial page based on the URL if there's a paged parameter
  const urlParams = new URLSearchParams(window.location.search);
  const initialPage = urlParams.get('paged') || 1;
  if (initialPage > 1) {
    filterPosts(initialPage); // Load the correct page on initial load
  }
});
